import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PlantillaPrestamoManagement = () => {
  const [plantilla, setPlantilla] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [jsonText, setJsonText] = useState('');

  useEffect(() => {
    cargarPlantilla();
  }, []);

  const cargarPlantilla = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/plantilla-prestamo');
      setPlantilla(response.data);
      setJsonText(JSON.stringify(response.data, null, 2));
    } catch (error) {
      console.error('Error al cargar plantilla:', error);
      setMensaje('Error al cargar la plantilla');
    } finally {
      setLoading(false);
    }
  };

  const guardarPlantilla = async () => {
    try {
      setSaving(true);
      const plantillaActualizada = JSON.parse(jsonText);
      await axios.put('/api/plantilla-prestamo', plantillaActualizada);
      setPlantilla(plantillaActualizada);
      setMensaje('✅ Plantilla guardada exitosamente');
      setTimeout(() => setMensaje(''), 3000);
    } catch (error) {
      console.error('Error al guardar plantilla:', error);
      setMensaje('❌ Error: ' + (error.response?.data?.message || error.message));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="management-container"><p>Cargando...</p></div>;
  }

  return (
    <div className="management-container">
      <h1>Plantilla de Solicitud de Préstamo</h1>
      
      <div className="form-group">
        <label htmlFor="plantilla">Plantilla (JSON):</label>
        <textarea
          id="plantilla"
          value={jsonText}
          onChange={(e) => setJsonText(e.target.value)}
          rows={20}
          style={{ width: '100%', fontFamily: 'monospace', padding: '10px', fontSize: '12px' }}
          placeholder="Contenido de la plantilla en JSON..."
        />
        <small style={{ display: 'block', marginTop: '10px', color: '#666' }}>
          💡 Puede usar variables como {'{nombreSolicitante}'}, {'{montoSolicitado}'}, etc.
        </small>
      </div>

      <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
        <button
          onClick={guardarPlantilla}
          disabled={saving}
          className="btn btn-primary"
          style={{ padding: '10px 20px', cursor: saving ? 'not-allowed' : 'pointer' }}
        >
          {saving ? 'Guardando...' : 'Guardar Plantilla'}
        </button>
        <button
          onClick={cargarPlantilla}
          disabled={loading || saving}
          className="btn btn-secondary"
          style={{ padding: '10px 20px', cursor: loading || saving ? 'not-allowed' : 'pointer' }}
        >
          Recargar
        </button>
      </div>

      {mensaje && (
        <div style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: mensaje.includes('✅') ? '#d4edda' : '#f8d7da',
          color: mensaje.includes('✅') ? '#155724' : '#721c24',
          borderRadius: '4px',
          border: `1px solid ${mensaje.includes('✅') ? '#c3e6cb' : '#f5c6cb'}`
        }}>
          {mensaje}
        </div>
      )}

      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
        <h3>Información de Uso</h3>
        <p>Esta plantilla se utiliza para generar automáticamente solicitudes de préstamo con los datos del socio.</p>
        <p><strong>Variables disponibles:</strong></p>
        <ul>
          <li>{'{nombreSolicitante}'} - Nombre completo</li>
          <li>{'{cedulaSolicitante}'} - Número de cédula</li>
          <li>{'{emailSolicitante}'} - Email</li>
          <li>{'{telefonoSolicitante}'} - Teléfono</li>
          <li>{'{montoSolicitado}'} - Monto del préstamo</li>
          <li>{'{plazoMeses}'} - Plazo en meses</li>
          <li>{'{tasaInteres}'} - Tasa de interés</li>
          <li>{'{fechaSolicitud}'} - Fecha actual</li>
        </ul>
      </div>
    </div>
  );
};

export default PlantillaPrestamoManagement;
